var global = require("app/utils/global");

module.exports = function() {
    var url,
        polyfillPromise,
        promiseResolver,
        script;

    // Url for polyfill service
    url = new URL("https://polyfill-fastly.io/v3/polyfill.min.js");
    url.searchParams.append("features", [
        "Array.prototype.includes",
        "Intl.DateTimeFormat",
        "Intl.Locale",
        "Intl.NumberFormat",
        "Intl.PluralRules",
        "Intl.RelativeTimeFormat",
        "Promise.allSettled",
        "Promise.any",
        "Promise.prototype.finally",
        "Promise",
        "String.prototype.includes",
        "String.prototype.replaceAll"
    ].join(","));
    url.searchParams.append("callback", "__polyfillCallback");

    // Promise to resolve when polyfill is done
    polyfillPromise = new Promise(function(resolve) {
        promiseResolver = resolve;
    });

    // Callback function will resolve the promise
    global.__polyfillCallback = function() {
        promiseResolver();
    };

    // Load the polyfills
    script      = document.createElement("script");
    script.src  = url.toString();
    script.type = "text/javascript";
    document.head.appendChild(script);

    return polyfillPromise;
};
